import Arrow from "../assets/arrow.svg";

export default function TopSlide({
  tag,
  reverse,
  min_height,
  light,
  font_size,
  title,
  text,
  link,
  bgDesktop,
  bgMobile,
  className,
}) {
  return (
    <section
      className={`relative min-w-full h-full flex flex-col ${min_height} ${className}`}
    >
      {!light && (
        <div
          className={[
            "absolute z-10 inset-0 hidden lg:block",
            light && reverse && "lg:gradient-light-desktop-reverse",
            light && !reverse && "lg:gradient-light-desktop",
            !light && reverse && "lg:gradient-dark-desktop-reverse",
            !light && !reverse && "lg:gradient-dark-desktop",
          ]
            .filter(Boolean)
            .join(" ")}
        />
      )}
      <div
        className={[
          "relative z-20 container lg:m-auto flex-grow lg:flex lg:items-center lg:bg-none border-b-8 border-white lg:border-none",
          reverse ? "lg:flex-row-reverse" : "lg:flex-row",
          light ? "gradient-light-mobile" : "gradient-dark-mobile",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="py-6 md:py-16 lg:py-8 lg:w-1/2">
          <div
            className={["lg:max-w-xl", reverse && "lg:mr-auto"]
              .filter(Boolean)
              .join(" ")}
          >
            {tag && (
              <p className="text-base text-blue-400 font-bold leading-6 md:text-2xl md:leading-8">
                {tag}
              </p>
            )}
            <h2
              className={[
                "font-medium lg:ml-10",
                light ? "text-blue-700" : "text-white",
                font_size.header || "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {title}
            </h2>
            {text && title && (
              <hr
                className={[
                  "border-3 rounded w-1/4 my-4 lg:w-1/6",
                  light
                    ? "border-blue-400 bg-blue-400"
                    : "border-blue-300 bg-blue-300",
                ]
                  .filter(Boolean)
                  .join(" ")}
              />
            )}
            <p
              className={[
                "leading-6 text-base lg:ml-10",
                light ? "text-blue-700" : "text-white",
                font_size.text,
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {text}
            </p>
            {link && link.url && link.title && (
              <a
                href={link.url}
                target={link.opensInNewTab ? "_blank" : "_self"}
                rel={link.opensInNewTab ? "noopener noreferrer" : ""}
                className={[
                  "leading-8 text-xl font-bold flex items-center mt-6 md:text-3xl md:leading-8",
                  light ? "text-blue-700" : "text-white",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <span>{link.title}</span>
                <Arrow
                  className={
                    "w-3 h-3 transform rtl:rotate-90 -rotate-90 mr-1 md:h-6 md:w-6"
                  }
                />
              </a>
            )}
          </div>
        </div>
      </div>

      {bgDesktop && (
        <img
          src={bgDesktop}
          alt={""}
          className={[
            "hidden lg:block w-full h-full object-cover lg:object-left lg:absolute lg:top-0 lg:bottom-0 lg:m-0",
            light ? "lg:w-full" : "lg:w-1/2",
            reverse ? "lg:right-0" : "lg:left-0",
          ]
            .filter(Boolean)
            .join(" ")}
        />
      )}
      {bgMobile && (
        <div className="lg:hidden pt-66% relative">
          <img
            src={bgMobile}
            alt={""}
            className={["w-full h-full object-cover absolute inset-0"]
              .filter(Boolean)
              .join(" ")}
          />
        </div>
      )}
    </section>
  );
}
